import functions from '../functions';
import { list } from './list';
import pagination from '../components/pagination';
import listResults from '../components/listResults';

$(() => {
    listTravel.init();
});

const listTravel = {
    $form: null,
    form: null,
    $filter: null,
    filter: null,
    defaults: {
        _page: 1,
        perPage: 12,
        language: functions.getLang(),
        arrivalDateFrom: '',
        destination: '',
        countryId: '',
        objectGroupId: 6,
        objectTypeId: null,
        guests: '',
        hasArrival: 2,
        hasDiscount: null,
        tagCategoryId: null,
        sortBy: 0,
    },
    params: {},
    isHome: false,
    $listItems: null,
    filterParams: {
        tagCategoryId: null,
        sortBy: null, 
        objectName: null,
        hasDiscount: null,
    },
    mainFields: ['arrivalDateFrom', 'destination', 'sortBy', '_page'],
    init() {
        this.$form = $('.search-form.search-travel');
        this.form = this.$form[0];


        if(! this.form || this.defaults.objectGroupId != this.$form.attr('data-objectgroupid')) {
            return;
        }

        this.$listItems = $('.list-items');
        this.isHome = this.$form.last().attr('data-ishome') || ! this.$listItems.length;

        this.listURL = this.$form.last().attr('action');    
        let defaultParams = this.$form.last().attr('data-params') ? JSON.parse(this.$form.last().attr('data-params')) : {};

        this.defaults.objectGroupId = defaultParams.objectGroupId;
        this.defaults.objectTypeId = defaultParams.objectTypeId;
        this.defaults.countryId = this.defaults.destination = defaultParams.countryId;
        this.filterParams.tagCategoryId = defaultParams.tagCategoryId;
        
        //this.defaults.objectGroupId = this.$form.last().attr('data-objectgroupid');
        //this.defaults.countryId = this.defaults.destination = this.$form.last().attr('data-countryid');
        //this.defaults.tagCategoryId = this.$form.last().attr('data-tagcategoryid');
        //this.filterParams.tagCategoryId = this.$form.last().attr('data-tagcategoryid');
        //this.filterParams.tagCategoryIds = this.$form.last().attr('data-tagcategoryids');
        //this.filterParams.hasDiscount = this.$form.attr('data-hasdiscount');
        
        this.$form.on('submit', e => {
            const $target = $(e.target);
            e.preventDefault();

            this.isHome = $target.attr('data-ishome') || this.isHome;

            if(this.isHome) {
                this.params.objectGroupId = $target.attr('data-objectgroupid');
                this.params.countryId = this.params.destination = $target.attr('data-countryid');
                this.params.perPage = $target.attr('data-perpage') || this.defaults.perPage;
            }

            this.params = $.extend({}, this.defaults, functions.getFormData($target));
            this.params._page = this.defaults._page;

            if(this.isHome) {
                this.params.objectGroupId = $target.attr('data-objectgroupid');
                this.params.tagCategoryId = $target.attr('data-tagcategoryid');
                this.params.tagCategoryIds = $target.attr('data-tagcategoryids');
                this.params.hasDiscount = $target.attr('data-hasdiscount');
                
                this.params = functions.cleanParams(this.params, this.defaults);
                location = $target.attr('action') + '#' + $.param(this.params);
            } else {
                functions.setUrlData(this.params, true, true, this.defaults);

                functions.isMobile() && $('#modalSearchTravel').modal('hide');
            }

        });

        if(! this.isHome) {

            this.getParams();           
            functions.setFormData(this.form, this.params);

            if(this.params.tagCategoryId) {
                const tagCategoryId = this.params.tagCategoryId.split(',');
                for (const tag of tagCategoryId) {
                    $('[name="tagCategoryId"][value="' + tag + '"]').prop('checked', true);
                }
            }

            this.params.guests = $('[name=guests]').val();
            this.find(this.params);
        } else {
            functions.setFormData(this.form, this.defaults);
        }

        if(list.params.destination) {
            $('.ms-clear').removeClass('d-none');
        } else {
            $('.ms-clear').addClass('d-none');
        }

        $('.ms-clear').on('click', e => {
            e.preventDefault();
            e.stopPropagation();

            const $target = $(e.currentTarget);
            this.params.destination = '';
            $target.siblings('[name="destination"]').val('').trigger('change');
        });

        /*$('[name="destination"]').on('change', e => {
            const $target = $(e.currentTarget);
            const value = $target.val();
            value && $('.ms-clear').removeClass('d-none');
            ! value && $('.ms-clear').addClass('d-none');
        });*/

        $('[name="tagCategoryId"]').on('change', e => {
            this.getParams();
            this.params._page = this.defaults._page;
            this.setTagCategoryId();
            //this.find(this.params);
            functions.setUrlData(this.params, true, true, this.defaults);
        });
        $('[name="hasDiscount"]').on('change', e => {
            this.params._page = this.defaults._page;
            this.getParams();
            this.params.hasDiscount = e.currentTarget.checked ? $(e.currentTarget).val() : null;
            functions.setUrlData(this.params, true, true, this.defaults);
        });

        list.setBtnSearchValue(this.params);

        $(window).on('hashchange', e => {
            this.getParams();
            this.setTagCategoryId();
            this.stopChangeEvents = true;

            functions.scrollToElement(this.$listItems, 100);
            this.find(this.params);
            this.stopChangeEvents = false;

            if(list.params.destination) {
                //$('.ms-clear').removeClass('d-none');
            } else {
                //$('.ms-clear').addClass('d-none');
            }

            list.setBtnSearchValue(this.params);
        });
    },
    getParams() {      
        this.params = list.getParams(this.params, this.defaults, this.filterParams);

        if(this.params.arrivalDateFrom) {
            
            let dateFrom = new Date(this.params.arrivalDateFrom);
            let month = dateFrom.getMonth() + 1;
            
            let lastDateOfMonth = new Date(dateFrom.getFullYear(), month, 0);
            this.params.arrivalDateTo = lastDateOfMonth.getFullYear() + '-' + (lastDateOfMonth.getMonth() + 1) + '-' + lastDateOfMonth.getDate();
        }
    },
    setTagCategoryId() {
        const $tagCategoryId = $('[name="tagCategoryId"]');

        if($tagCategoryId.length) {
            let tagCategoryIds = [];
            $tagCategoryId.each((index, target) => {
                const $target = $(target);
                if($target[0].checked) {
                    tagCategoryIds.push($target.val());
                }
            });
            this.params.tagCategoryId = tagCategoryIds.join(",");
        }
    },
    find(params) {
        list.find(params).then((response) => {
            this.findDone(response);
            // LOZAD
            window.observer.observe();
        });
    },
    findDone(response) {
        response = JSON.parse(response);          

        list.unsetLoadingMode();

        this.total = response.total;

        this.$listItems.html(response.html);
        if (this.total != 0) {

            if($('.paginate')[0]) {
                $('.paginate').html(pagination({
                    currentPage: this.params._page,
                    total: this.total,
                    perPage: this.params.perPage,
                }));
            }
        }

        listResults.getResults(this.total, this.params._page, this.params.perPage);

        this.initComponents();

    },
    paginate(page) {
        if (page != this.params._page) {
            this.params._page = page;
        }

        functions.setUrlData(this.params, true, false, this.defaults);
    },
    initComponents() {
        $('[data-page]').on('click', e => {
            e.preventDefault();
            this.paginate(+$(e.currentTarget).attr('data-page'));
        });

        let $dropdown = $(".dropdown-sort-by");
        $dropdown.find('.dropdown-item').on('click', function (e) {
            e.preventDefault();
            list.params._page = 1;
            list.params.sortBy = $(e.currentTarget).attr('href');
            functions.setUrlData(list.params, true, list.defaults);
        });

        if (list.params.sortBy) {
            let text = $dropdown.find(".dropdown-item[href='"+list.params.sortBy+"']").html();
            $dropdown.find(".btn .sort-by-value").html(text);
        }
    }

};